import React from "react";

const UpcomingCourseLoader = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          key={item}
          className="animate-pulse rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
        >
          {/* Top row */}
          <div className="flex items-center justify-between gap-3">
            <div className="h-5 bg-gray-200 rounded-md w-2/3" />

            <div className="h-6 bg-gray-200 rounded-full w-16" />
          </div>

          {/* Bottom action area */}
          <div className="flex items-center justify-between mt-5">
            <div className="h-3 bg-gray-200 rounded w-20" />

            <div className="flex gap-2">
              <div className="h-8 w-8 bg-gray-200 rounded-lg" />
              <div className="h-8 w-8 bg-gray-200 rounded-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UpcomingCourseLoader;    